import { React, useState, useEffect } from "react";
import Accounts from "./Accounts"

function Account() {
    return  <Accounts/>
            
}

export default Account;
